import { render, staticRenderFns } from "./DetailPacking.vue?vue&type=template&id=76eca83b&scoped=true&"
import script from "./DetailPacking.vue?vue&type=script&lang=js&"
export * from "./DetailPacking.vue?vue&type=script&lang=js&"
import style0 from "./DetailPacking.vue?vue&type=style&index=0&id=76eca83b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eca83b",
  null
  
)

export default component.exports